import React, { FC } from 'react';
import { UserProfileLinkTypeEnum } from '@src/graphql/generated';
import { View } from './View';
import { Message } from './Message';
import { LinkedIn } from './LinkedIn';
import { Save } from './Save';
import { Share } from './Share';
import { ActionTypes } from './enums/actionTypes.enum';
import { Props } from './props';
import './styles.scss';

export const Actions: FC<Props> = ({
  hiddenActions = [],
  isUserVerified,
  verifiedUser,
  copyText,
  onLinkedInClick,
  onMessageClick,
}) => {
  const linkedIn = verifiedUser.user.profile.links.find(({ type }) => type === UserProfileLinkTypeEnum.LINKEDIN);
  const linkedInUrl = linkedIn?.value;
  const hasRecruiterMessaged = verifiedUser.recruiterState.hasMessaged;

  return (
    <div className="talent-feed-item-actions">
      {!hiddenActions.includes(ActionTypes.VIEW) && <View isUserVerified={isUserVerified} />}

      {!hiddenActions.includes(ActionTypes.MESSAGE) && (
        <Message
          hasRecruiterMessaged={hasRecruiterMessaged}
          isUserVerified={isUserVerified}
          onMessageClick={onMessageClick}
        />
      )}

      {!hiddenActions.includes(ActionTypes.SHARE) && <Share copyText={copyText} isUserVerified={isUserVerified} />}

      {!hiddenActions.includes(ActionTypes.LINKEDIN) && (
        <LinkedIn
          hasRecruiterMessaged={hasRecruiterMessaged}
          isUserVerified={isUserVerified}
          linkedInUrl={linkedInUrl}
          onLinkedInClick={onLinkedInClick}
        />
      )}

      {!hiddenActions.includes(ActionTypes.SAVE) && <Save user={verifiedUser.user} />}
    </div>
  );
};
